'use client';

import { cn } from '@packages/shared/src/utils/cn/cn';
import { type BypassBlockProps } from './BypassBlock';

type BypassBlockLinkProps = Omit<BypassBlockProps, 'children' | 'buttonText'> & {
  /**
   * The id of the anchor element.
   */
  anchorId: string;
  /**
   * The text of the bypass link.
   */
  linkText: string;
};

/**
 * A Link that allows users to skip a block of content.
 */
export const BypassLink = ({
  linkText,
  skipScrollIntoView,
  anchorId,
  className,
}: BypassBlockLinkProps) => (
  <a
    href={`#${anchorId}`}
    className={cn(
      'text-size-headline-base bg-color-grey-light hover:bg-color-grey focus-visible:bg-color-grey focus-visible:border-color-info text-color-info-contrasttext focus-visible:z-tooltip absolute block h-0 w-0 overflow-hidden rounded-sm border-0 p-0 text-center font-bold whitespace-normal no-underline focus-visible:top-2.5 focus-visible:left-2.5 focus-visible:h-auto focus-visible:w-auto focus-visible:rounded-sm focus-visible:border-2 focus-visible:border-solid focus-visible:p-2.5 focus-visible:shadow-md',
      className,
    )}
    onClick={(e) => {
      e.preventDefault();
      const element = document.getElementById(anchorId);
      if (element) {
        // fixes excess scroll issue for header skip links
        requestAnimationFrame(() => {
          const rect = element.getBoundingClientRect();
          !skipScrollIntoView &&
            window.scrollTo({
              left: 0,
              top: rect.top + window.scrollY,
              behavior: 'smooth',
            });
        });
        element.focus();
        //  workaround for smooth scrolling needed, if the target element is not a native button. (on a simple div or other non interative elements, focus is immediately triggered before finishing the smooth scroll)
        // setTimeout(() => {
        //   element.focus();
        // }, 400);
      }
    }}
  >
    {linkText}
  </a>
);
